// components/Header.jsx
import React, { useState } from "react";
import { NavLink as RRNavLink } from "react-router-dom";
import MenuIcon from "./icons/MenuIcon";
import favicon from './icons/favicon.png';


const Item = ({ children, to, href, onClick, className ="" }) => (
  <li>
  {to ? (
    <RRNavLink
      to={to}
      onClick={onClick}
      className={`block px-3 py-2 text-sm text-gray-300 text-center hover:bg-[#2A2B2F] hover:text-white transition-colors duration-300 ${className}`}
    >
      {children}
    </RRNavLink>
  ) : (
    <a
      href={href}
      onClick={onClick}
      className={`block px-3 py-2 text-sm text-gray-300 text-center hover:bg-[#2A2B2F] hover:text-white transition-colors duration-300 ${className}`}
    >
      {children}
    </a>
  )}
</li>
);

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);


  return (
    <header className="relative flex items-center justify-between">
      <a href="/" aria-label="Go to homepage">
      <img src={favicon} alt="Megumi" className="w-8 h-8 rounded-full hover:scale-105 transition-transform duration-200" />
      </a>
      <nav className="hidden md:block">
        <ul className="flex items-center space-x-2 bg-[#1C1D20] p-1 rounded-full">
          <Item href="/#about" className="rounded-l-full">About</Item>
          <Item href="/#work">Work</Item>
          <Item to="/blog">Blog</Item>
          <Item href="/#contact" className="rounded-r-full">Contact</Item>
        </ul>
      </nav>


      {/* Hamburger Icon */}
      <div className="md:hidden">
        <button onClick={toggleMenu} className="md:hidden text-gray-400">
        <MenuIcon className="h-6 w-6" />
      </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
  <div className="absolute top-full right-4 mt-3 w-48 bg-[#1C1D20] border border-gray-700 rounded-xl shadow-xl shadow-black/40 z-50 transition-all duration-300">
    <ul className="flex flex-col divide-y divide-gray-700">
      <Item href="/#about" onClick={closeMenu}>About</Item>
      <Item href="/#work" onClick={closeMenu}>Work</Item>
      <Item to="/blog" onClick={closeMenu}>Blog</Item>
      <Item href="/#contact" onClick={closeMenu}>Contact</Item>
    </ul>
  </div>
)}
    </header>
  );
}
